var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubOrganizations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.002,
    height: 84.362,
    viewBox: "0 0 91.002 84.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sub_organizations",
    transform: "translate(0.51 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11354",
    "data-name": "Path 11354",
    d: "M47.661,27.1V41.143h25.5A5.957,5.957,0,0,1,79.1,47.08v9.178h3.924a6.986,6.986,0,0,1,6.972,6.972V76.39a7.006,7.006,0,0,1-6.972,6.972H69.86a6.994,6.994,0,0,1-6.972-6.972V63.23a6.986,6.986,0,0,1,6.972-6.972h3.577V47.08a.276.276,0,0,0-.278-.278h-25.5v9.456h3.75a6.986,6.986,0,0,1,6.972,6.972V76.39a7.006,7.006,0,0,1-6.972,6.972H38.253A6.994,6.994,0,0,1,31.28,76.39V63.23a6.986,6.986,0,0,1,6.972-6.972H42V46.8h-25.5a.276.276,0,0,0-.278.278v9.178H20.12a6.985,6.985,0,0,1,6.972,6.972V76.39a7.005,7.005,0,0,1-6.972,6.972H6.962A6.994,6.994,0,0,1-.01,76.39V63.23a6.985,6.985,0,0,1,6.972-6.972h3.606V47.08a5.957,5.957,0,0,1,5.937-5.937H42V27.1h-3.75A6.994,6.994,0,0,1,31.28,20.13V6.972A6.986,6.986,0,0,1,38.253,0H51.412a6.986,6.986,0,0,1,6.972,6.972V20.13A7.005,7.005,0,0,1,51.412,27.1Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubOrganizations);
export default __webpack_public_path__ + "static/media/sub_organizations.68a50a53977648d7cd1cdcf873949eac.svg";
export { ForwardRef as ReactComponent };